import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "scheduled-message-list",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "メッセージ配信", -1)
const _hoisted_3 = { class: "scheduled-message-list-body" }

import { onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { get, set } from "@vueuse/core";
import { MessageService } from "@/clinic/services";
import { MessageItem } from "@/clinic/typings";
import Header from "@/clinic/components/atoms/Grid/header.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/clinic/constants/router.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();

const scheduledMessages = ref<MessageItem[]>([]);
const channelId = ref(0);
const columns = ref([
  { field: "category", header: "ステータス" },
  { field: "title", header: "タイトル" },
  { field: "status", header: "配信状況" },
  { field: "send_date", header: "配信予約日時" },
  { field: "created_at", header: "作成日時" },
  { field: "message_open_object", header: "配信対象者" },
  { field: "amount_opened_messages", header: "開封数" },
]);

const getScheduledMessages = async () => {
  set(channelId, await store.dispatch("authClient/getChannelIdCookie"));
  const { data: messageList } = await MessageService.list(get(channelId));
  set(
    scheduledMessages,
    messageList.messages.map(message => {
      return new MessageItem(message);
    })
  );
};

const movetoNewScheduledMessage = () => RouterUtils.goTo(RouterConstants.MESSAGE_NEW_ROUTER_NAME);

const onItemClick = async (_: any, item: any) => {
  RouterUtils.goToWithParams(RouterConstants.MESSAGE_EDIT_ROUTER_NAME, { id: item.id });
};

onBeforeMount(async () => await getScheduledMessages());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Header, {
      onNew: movetoNewScheduledMessage,
      createButtonLabel: "新規作成"
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Grid, {
        items: scheduledMessages.value,
        columns: columns.value,
        onOnItemClick: onItemClick
      }, null, 8, ["items", "columns"])
    ])
  ]))
}
}

})